import { Visibility } from '@mui/icons-material';
import { Grid, IconButton, useEventCallback } from '@mui/material';
import { memo, ReactElement, useEffect, useMemo, useState } from 'react';
import Table from 'shell/components/shared/table';
import { headCellsAct, headCellsPerson } from './constants';
import { noop } from 'shell/utils/noop';
import { generatePath, useNavigate } from 'react-router-dom';
import { ActListVM } from 'civil-status/view-models/research-category-form';
import {
  FilterType,
  FilterTypeState,
  urlAct,
  urlEvent,
} from 'civil-status/pages/research-category/list';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { ActCategory, ModelEventoDTO } from 'shell/models/act-category-list';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { transformerActCategoryList } from 'civil-status/utils/transformer-act-category-list';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';

interface TableActProps {
  data?: Array<ActListVM>;
  filterSelected?: FilterTypeState;
  setFilterSelected: (value: FilterTypeState) => void;
  getActListData: (url: string, data?: FilterType, page?: number, rowsPerPage?: number) => void;
  idCat?: string;
  valueCat?: string;
  tableProps?: Record<string, number>;
  setTableProps: (values: Record<string, number>) => void;
  isChooseAct?: boolean;
  onChoosePress: (item: ActListVM) => void;
  isCommunications?: boolean;
  setTablePropsFilterTable?: (page?: number, rowsPerPage?: number) => void;
  isRactod343?: boolean;
  isRactod344?: boolean;
  isRactod341?: boolean;
  isRactod441?: boolean;
  isRactod350?: boolean;
  isRactod0216?: boolean;
  isRactod0103?: boolean;
}

const TableActComponent = ({
  data,
  filterSelected,
  setFilterSelected,
  getActListData,
  idCat = '',
  valueCat = '',
  tableProps = {},
  setTableProps,
  isChooseAct = false,
  onChoosePress,
  isCommunications = false,
  setTablePropsFilterTable,
  isRactod343,
  isRactod344,
  isRactod341,
  isRactod441,
  isRactod350,
  isRactod0216,
  isRactod0103,
}: TableActProps): ReactElement => {
  const navigate = useNavigate();

  const [isAct, setIsAct] = useState<boolean>(false);
  const [dataList, setDataList] = useState<Array<ActListVM> | undefined>();

  useEffect(() => {
    setDataList(data);
  }, [data]);

  useEffect(() => {
    setIsAct(filterSelected?.url === urlAct || filterSelected?.url === urlEvent);
  }, [filterSelected]);

  const pathPersonDetail: string = useMemo(() => {
    if (isCommunications) {
      return '/stato-civile/ricerca-comunicazioni/:valueCat/:idCat/visualizza/:id/persona';
    }
    return '/stato-civile/:valueCat/:idCat/ricerca/visualizza/:id/persona';
  }, [isCommunications]);

  const pathDetail: string = useMemo(() => {
    if (isCommunications) {
      return '/stato-civile/ricerca-comunicazioni/:valueCat/:idCat/visualizza/:id';
    }
    return '/stato-civile/:valueCat/:idCat/ricerca/visualizza/:id';
  }, [isCommunications]);

  const [actPerson, getActPerson] = useHttpFetch<HttpResponse<ActCategory>, Array<ActListVM>>(
    `${__ACT_API_URL__}/consultazione/soggetto`,
    {
      onBootstrap: false,
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
        data: {},
      },
      transformer: (res) => transformerActCategoryList(res, true),
    }
  );

  const redirectCat = useEventCallback((item: ActListVM) => {
    if (!item.idAnsc) {
      return;
    }

    if (item.isResearchPerson || !isAct) {
      navigate({
        pathname: generatePath(pathPersonDetail, {
          id: item.idAnsc,
          valueCat,
          idCat,
        }),
      });

      return;
    }

    navigate({
      pathname: generatePath(pathDetail, {
        id: item.idAnsc,
        valueCat,
        idCat,
      }),
    });
  });

  const onDetailPress = useEventCallback((item: ActListVM) => {
    if (idCat && valueCat) {
      redirectCat(item);
      return;
    }

    if (!item.idAnsc) {
      return;
    }

    if (item.isResearchPerson || !isAct) {
      (
        getActPerson({
          data: {
            criteriRicercaSoggetto: {
              idAnscSoggetto: item.idAnsc,
            },
          },
        }) as ResponsePromise<HttpResponse<ActCategory>, Array<ActListVM>>
      ).then((response) => {
        const castedResponse = (response || []) as Array<ActListVM>;

        if (castedResponse.length === 1) {
          navigate({
            pathname: generatePath('/stato-civile/ricerca-atti/visualizza/:id/persona', {
              id: item.idAnsc || '',
            }),
          });
        } else {
          // permettere la visualizzazione degli atti
          setIsAct(true);
        }
      });

      setDataList(undefined);
      setFilterSelected({
        filter: filterSelected?.filter || {},
        url: '',
      });

      return;
    }

    navigate({
      pathname: generatePath('/stato-civile/ricerca-atti/visualizza/:id', {
        id: item.idAnsc,
      }),
    });
  });

  const disabledButton = useEventCallback((item: ActListVM) => {
    const itemSaved: ModelEventoDTO = item.itemSaved || {};

    if (
      isRactod341 ||
      isRactod441 ||
      isRactod350 ||
      // isRactod0216
      isRactod0103
    ) {
      const tipoContenutoInvalid = ['2', '4', '5'];

      if (tipoContenutoInvalid.includes(itemSaved.idtipocontenuto || '')) {
        return true;
      }
    }

    if (isRactod343) {
      const controllRactod =
        (itemSaved.idUsecase === '341000' || itemSaved.idUsecase === '342000') &&
        item.state?.toUpperCase() === 'FIRMATO DA USC';

      return !controllRactod;
    }

    if (isRactod344) {
      const controllRactod =
        (itemSaved.idUsecase === '341000' ||
          itemSaved.idUsecase === '342000' ||
          itemSaved.idUsecase === '343000') &&
        item.state?.toUpperCase() === 'FIRMATO DA USC';

      return !controllRactod;
    }

    if (isRactod341) {
      const UcInvalid = [
        '341000',
        '342000',
        '343000',
        '344000',
        '345000',
        '346000',
        '347000',
        '348000',
        '350000',
      ];

      if (UcInvalid.includes(itemSaved.idUsecase || '')) {
        return true;
      }

      return item.state?.toUpperCase() !== 'FIRMATO DA USC';
    }

    if (isRactod0216) {
      const UcValid = ['12212300', '12216300', '12422300'];

      if (UcValid.includes(itemSaved.idUsecase || '')) {
        return item.state?.toUpperCase() !== 'FIRMATO DA USC';
      }

      return true;
    }

    if (isRactod0103) {
      const UcValid = ['12211312', '12216300', '12214300'];

      if (UcValid.includes(itemSaved.idUsecase || '')) {
        return item.state?.toUpperCase() !== 'FIRMATO DA USC';
      }

      return true;
    }

    if (isRactod441) {
      const UcInvalid = ['441000', '442000', '443000', '444000', '445000'];

      if (UcInvalid.includes(itemSaved.idUsecase || '')) {
        return true;
      }

      return item.state?.toUpperCase() !== 'FIRMATO DA USC';
    }

    if (isRactod350) {
      const UcInvalid = [
        '347000',
        '346000',
        '347000',
        '341000',
        '342000',
        '344000',
        '346000',
        '347000',
        '348000',
        '350000',
      ];

      if (UcInvalid.includes(itemSaved.idUsecase || '')) {
        return true;
      }

      return item.state?.toUpperCase() !== 'FIRMATO DA USC';
    }

    const isDisabled = item.state?.toUpperCase() !== 'FIRMATO DA USC' && isAct;

    return isDisabled;
  });

  const checkRactod350 = useHttpClient(`${__ACT_API_URL__}/atto/controlli/verifica-atto`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  const controlsRactod350 = useEventCallback((item: ActListVM) => {
    if (!item.itemSaved) {
      return;
    }

    (
      checkRactod350({
        data: {
          ...item.itemSaved,
        },
      }) as ResponsePromise<void>
    ).then(() => {
      // Se non ci sono errori continuare con l'inizializzazione

      if (isChooseAct) {
        onChoosePress(item);
      } else {
        onDetailPress(item);
      }
    });
  });

  const body: Array<ActListVM> = useMemo(() => {
    return (dataList || (actPerson.data as Array<ActListVM>) || []).map((item) => {
      return {
        ...item,
        action: (
          <div className="pmi-d-flex">
            <IconButton
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                if (isRactod350) {
                  controlsRactod350(item);
                  return;
                }

                if (isChooseAct) {
                  onChoosePress(item);
                } else {
                  onDetailPress(item);
                }
              }}
              aria-label={isChooseAct ? 'Selezione elemento' : 'Visualizza elemento'}
              aria-haspopup="true"
              disabled={disabledButton(item)}
              style={{
                padding: '4px',
              }}
            >
              <Visibility />
            </IconButton>
          </div>
        ),
      };
    });
  }, [dataList, actPerson, isAct]);

  const onChangePage = useEventCallback((page: number) => {
    getActListData(
      filterSelected?.url || '',
      filterSelected?.filter || {},
      page,
      tableProps.rowsPerPage
    );

    if (setTablePropsFilterTable) {
      setTablePropsFilterTable(page, tableProps.rowsPerPage);
    }

    setTableProps({
      page,
      rowsPerPage: tableProps.rowsPerPage,
    });
  });

  const onChangeRowsPerPage = useEventCallback((rowsPerPage: number) => {
    getActListData(filterSelected?.url || '', filterSelected?.filter || {}, 0, rowsPerPage);

    if (setTablePropsFilterTable) {
      setTablePropsFilterTable(0, rowsPerPage);
    }

    setTableProps({
      page: 0,
      rowsPerPage,
    });
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Table
          ariaLabel="Lista pratiche"
          page={tableProps.page || 0}
          rowsPerPage={tableProps.rowsPerPage || 10}
          body={body}
          count={(body && body[0]?.totalCount) || 0}
          head={isAct ? headCellsAct : headCellsPerson}
          onSort={noop}
          onPageChange={onChangePage}
          onRowsPerPageChange={onChangeRowsPerPage}
          orders={{}}
          isNotLayoutFixed
          noSort
          hideButtons
          isServer
        />
      </Grid>
    </Grid>
  );
};

TableActComponent.displayName = 'Practice Research - Table Persons component';

const TableAct = memo(TableActComponent);

export default TableAct;
